import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('accessToken');
  return { Authorization: `Bearer ${token}` };
};

// Configuration
export const getPurgeConfig = async () => {
  const response = await axios.get(`${API_URL}/purge/config`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updatePurgeConfig = async (config) => {
  const response = await axios.put(`${API_URL}/purge/config`, config, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Statistics
export const getPurgeStats = async (days = 30) => {
  const response = await axios.get(`${API_URL}/purge/statistics`, {
    params: { days },
    headers: getAuthHeader()
  });
  return response.data;
};

export const getPurgeHistory = async (params = {}) => {
  const response = await axios.get(`${API_URL}/purge/history`, {
    params,
    headers: getAuthHeader()
  });
  return response.data;
};

export const getEligibleItems = async (retentionDays, limit = 50, offset = 0) => {
  const params = { limit, offset };
  if (retentionDays) params.retentionDays = retentionDays;

  const response = await axios.get(`${API_URL}/purge/eligible`, {
    params,
    headers: getAuthHeader()
  });
  return response.data;
};

// Execution
export const executeDryRun = async () => {
  const response = await axios.post(
    `${API_URL}/purge/dry-run`,
    {},
    {
      headers: getAuthHeader()
    }
  );
  return response.data;
};

export const executePurge = async (options = {}) => {
  const response = await axios.post(`${API_URL}/purge/execute`, options, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Job Control
export const getPurgeJobStatus = async () => {
  const response = await axios.get(`${API_URL}/purge/status`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const startPurgeJob = async () => {
  const response = await axios.post(
    `${API_URL}/purge/start`,
    {},
    {
      headers: getAuthHeader()
    }
  );
  return response.data;
};

export const stopPurgeJob = async () => {
  const response = await axios.post(
    `${API_URL}/purge/stop`,
    {},
    {
      headers: getAuthHeader()
    }
  );
  return response.data;
};
